import { render, staticRenderFns } from "./BrowseSelectionTotals.vue?vue&type=template&id=0b97e2c8&scoped=true"
import script from "./BrowseSelectionTotals.vue?vue&type=script&lang=ts"
export * from "./BrowseSelectionTotals.vue?vue&type=script&lang=ts"
import style0 from "./BrowseSelectionTotals.vue?vue&type=style&index=0&id=0b97e2c8&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b97e2c8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0b97e2c8')) {
      api.createRecord('0b97e2c8', component.options)
    } else {
      api.reload('0b97e2c8', component.options)
    }
    module.hot.accept("./BrowseSelectionTotals.vue?vue&type=template&id=0b97e2c8&scoped=true", function () {
      api.rerender('0b97e2c8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/browse/BrowseSelectionTotals.vue"
export default component.exports